var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLmtDownArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1998_24675)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(0.5)",
    fill: "current",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9686 6.27031H11.703C11.6311 6.27031 11.5623 6.30156 11.5139 6.35625L8.09359 10.2984V1.5C8.09359 1.43125 8.03734 1.375 7.96859 1.375H7.03109C6.96234 1.375 6.90609 1.43125 6.90609 1.5V10.2984L3.48577 6.35625C3.4389 6.30156 3.37015 6.27031 3.29671 6.27031H2.03109C1.92484 6.27031 1.86702 6.39687 1.93734 6.47656L7.12327 12.4531C7.17015 12.5072 7.22811 12.5506 7.29321 12.5803C7.35831 12.61 7.42905 12.6254 7.50062 12.6254C7.57219 12.6254 7.64292 12.61 7.70802 12.5803C7.77313 12.5506 7.83108 12.5072 7.87796 12.4531L13.0623 6.47656C13.1326 6.39531 13.0748 6.27031 12.9686 6.27031Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1998_24675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "current",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLmtDownArrowIcon);
export default __webpack_public_path__ + "static/media/lmt-down-arrow-icon.61a909f1804c45a3abd1a16e702640c9.svg";
export { ForwardRef as ReactComponent };